import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { fastTransition } from '../../../styles/tokens';

const firstChild = ':first-of-type:not(* + *)';

export const Container = styled(Box)(({ theme }) => ({
  position: 'relative',
  paddingBottom: theme.palette.tokens.space[5],

  [`& > ${firstChild} + *, & > ${firstChild} + * > ${firstChild}`]: {
    marginTop: 0,
  },
}));

export const ProgressBar = styled(Box)(() => ({
  position: 'absolute',
  left: 0,
  top: 0,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

interface IconProps {
  complete: 'true' | 'false';
}

export const Icon = styled(Box)<IconProps>(({ complete, theme }) => ({
  display: 'flex',
  height: theme.typography.h6.lineHeight,
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  background: theme.palette.background.default,
  span: {
    color:
      complete === 'true'
        ? theme.palette.tokens.color.positive
        : theme.palette.tokens.color.warning,
    fontSize: 22,
    transition: fastTransition(theme.palette.tokens.motion, 'color'),
  },
}));

export const Line = styled(Box)<IconProps>(({ complete, theme }) => ({
  height: '100%',
  width: '1px',
  background:
    complete === 'true'
      ? theme.palette.tokens.color.positive
      : theme.palette.divider,
  transition: fastTransition(theme.palette.tokens.motion, 'background-color'),
}));
